// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__RGIme","wrapper":"Carousel_wrapper__1ZpB9","carousel":"Carousel_carousel__1RJmE"};